<template>
  <div class="text-center">
    <v-card class="list-area-box">
      <v-list class="list-area">
        <v-list-item>
          <v-list-item-title>학자금 구분</v-list-item-title>
          <v-list-item-subtitle> {{ schClsfiNm }} </v-list-item-subtitle>
        </v-list-item>
        <v-list-item>
          <v-list-item-title>대상자명</v-list-item-title>
          <v-list-item-subtitle> {{ tgtName }} </v-list-item-subtitle>
        </v-list-item>
        <v-list-item>
          <v-list-item-title>생년월일</v-list-item-title>
          <v-list-item-subtitle> {{ tgtBirth }} </v-list-item-subtitle>
        </v-list-item>
        <v-list-item>
          <v-list-item-title>학교</v-list-item-title>
          <v-list-item-subtitle> {{ schlNm }} </v-list-item-subtitle>
        </v-list-item>
        <v-list-item>
          <v-list-item-title>학년</v-list-item-title>
          <v-list-item-subtitle> {{ schlYyNm }} </v-list-item-subtitle>
        </v-list-item>
        <v-list-item>
          <v-list-item-title>신청분기</v-list-item-title>
          <v-list-item-subtitle> {{ tgtQtNm }} </v-list-item-subtitle>
        </v-list-item>
        <v-list-item>
          <v-list-item-title>신청금액</v-list-item-title>
          <v-list-item-subtitle>
            {{ Number(applAmnt).toLocaleString() }}원
          </v-list-item-subtitle>
        </v-list-item>
        <v-list-item>
          <v-list-item-title>기지급액</v-list-item-title>
          <v-list-item-subtitle>
            {{ Number(payAmnt).toLocaleString() }}원
          </v-list-item-subtitle>
        </v-list-item>
        <v-list-item>
          <v-list-item-title>지급한도/연</v-list-item-title>
          <v-list-item-subtitle>
            {{ Number(maxAmnt).toLocaleString() }}원
          </v-list-item-subtitle>
        </v-list-item>
      </v-list>
    </v-card>
  </div>
</template>
<script>
import { getEdusAppDetail, getEtcSchClsfiCd } from '@/api/workStatus';
import { mapMutations, mapGetters } from 'vuex';
import dayjs from 'dayjs';
import { getUiInfo } from '@/api/approvalCommon';

export default {
  data: () => ({
    schClsfiNm: '',
    tgtName: '',
    schlNm: '',
    schlYyNm: '',
    tgtQtNm: '',
    applAmnt: 0,
    payAmnt: 0,
    tgtBirth: '',
    maxAmnt: 0,
  }),
  props: {
    appInfoParam: Object,
  },
  computed: {
    ...mapGetters(['GET_USER_DATA', 'GET_SEQ_NO']),
    scrollViewStyle() {
      return `max-height: ${
        window.innerHeight - this.$store.getters.HEIGHT_BOTTOM_NAV
      }px`;
    },
  },

  methods: {
    ...mapMutations('SPINNER', ['ON_APP_SPINNER', 'OFF_APP_SPINNER']),
  },

  async created() {
    this.appInfoParam.seqNo = this.GET_SEQ_NO === '' ? 1 : this.GET_SEQ_NO;

    let response = await getEdusAppDetail(this.appInfoParam);

    let params = {
      schClsfiCd: response.data.data.schClsfiCd,
      searchApplSabun: this.GET_USER_DATA.ssnSabun,
      searchApplYmd: dayjs().format('YYYYMMDD'),
    };

    const response2 = await getEtcSchClsfiCd(params);

    this.schClsfiNm = response.data.data.schClsfiNm;
    this.tgtName = response.data.data.tgtName;
    this.schlNm = response.data.data.schlNm;
    this.schlYyNm = response.data.data.schlYyNm;
    this.tgtQtNm = response.data.data.tgtQtNm;
    this.applAmnt = response.data.data.applAmnt;
    this.payAmnt = response.data.data.payAmnt;
    this.tgtBirth = response.data.data.tgtBirthYmd;
    this.maxAmnt = response2.data.data.edusPayStdCheck.maxAmnt;

    if (response.data.data.genderCd === '1') {
      this.tgtBirth += ' / 남';
    } else {
      this.tgtBirth += ' / 여';
    }

    response = await getUiInfo(this.appInfoParam);
    console.dir(response);

    if (response.data.data.fileYn === 'N') {
      this.$emit('showFileView', false);
    } else {
      this.$emit('showFileView', true);
    }

    this.OFF_APP_SPINNER();
  },

  components: {},
};
</script>
